import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { getEmbeddedResource } from '@ngxp/rest';
import { StateResource } from '@schir-int-client/ngrx-helpers';
import { isNil, isNull } from 'lodash-es';
import { VorgangListLinkRel } from './vorgang.linkrel';
import { DatumsBereich, VorgangResource } from './vorgang.model';
import { vorgangFeatureState, VorgangRootState } from './vorgang.state';
import { sameUri } from '@schir-int-client/tech';

export const selectFeature = createFeatureSelector<VorgangRootState>(vorgangFeatureState);

export function vorgaengeByVerfahrenSelector(verfahrenUri: string) {
	return createSelector(selectFeature, (state: VorgangRootState) => {
		if (!isNil(state.vorgangRoot.vorgaengeByVerfahren)) {
			return state.vorgangRoot.vorgaengeByVerfahren[verfahrenUri];
		}
	});
}

export const vorgangSelector: MemoizedSelector<
	object,
	StateResource<VorgangResource>,
	DefaultProjectorFn<StateResource<VorgangResource>>
> = createSelector(selectFeature, (state: VorgangRootState) => {
	return state.vorgangRoot.selectedVorgang;
});

export const vorgaengeRechtspflegerSelector = createSelector(selectFeature, (state: VorgangRootState) => {
	if (!isNull(state.vorgangRoot)) {
		return state.vorgangRoot.vorgaengeRechtspflege;
	}
	return null;
});

export const vorgaengeInRuecklaufSelector = createSelector(selectFeature, (state: VorgangRootState) => {
	if (!isNil(state.vorgangRoot.vorgaengeInRuecklauf)) {
		return getEmbeddedResource<VorgangResource[]>(
			state.vorgangRoot.vorgaengeInRuecklauf,
			VorgangListLinkRel.VORGANG_LIST
		);
	}
	return null;
});

export const isVorgangSelectedSelector = (vorgangResource: VorgangResource) =>
	createSelector(selectFeature, (state: VorgangRootState) => {
		return (
			state.vorgangRoot.selectedVorgang.loaded &&
			sameUri(state.vorgangRoot.selectedVorgang.resource, vorgangResource)
		);
	});

export const vorgaengeInWiedervorlageSelector: MemoizedSelector<
	object,
	StateResource<VorgangResource[]>
> = createSelector(selectFeature, (state: VorgangRootState) => {
	const selected = state.vorgangRoot.vorgaengeInWiedervorlage;

	if (isNull(selected.resource)) {
		return { ...selected, resource: [] };
	}
	return {
		...selected,
		resource: <VorgangResource[]>getEmbeddedResource(selected.resource, VorgangListLinkRel.VORGANG_LIST),
	};
});

export const datumsBereichSelector: MemoizedSelector<object, DatumsBereich> = createSelector(
	selectFeature,
	(state: VorgangRootState) => {
		return state.vorgangRoot.datumsBereich;
	}
);
